<div>
   <div class="row">
        <div class="col-md-12">
            <div class="card-box">
                <div v-show="!loading">
                    <data-table :headings="collectionOrderHeadings" :data="orders" :hasActions="true"
                                :pagingDetails="pagingDetails"
                                :stateChanged="filterStateChanged"
                                @pagingUpdated="onPagingUpdated"
                                @actionClicked="onOrderActionClicked" @filterSearchClicked="onFilterSearchClicked">
                        <template #actionButton>
                            <div class="w-100" v-show="!loading">
                                <button class="btn btn-primary" @click="onAddOrderClick" id="btnOrdersDeliveryAddOrder" v-if="!company.suspended">Add Order</button>
                            </div>
                            <div class="w-100 text-danger" v-show="company.suspended">
                                Suspended, cannot place orders
                            </div>
                        </template>
                        <template #filter>
                            <div class="p-3">
                                <div class="input-group pb-4">
                                    <input type="text" class="form-control" placeholder="Search" aria-label="Search" aria-describedby="basic-addon1" v-model="filter.customerSearchQuery">
                                    <div class="input-group-append">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fas fa-search"></i>
                                    </span>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-sm-6">
                                        <label>Order Status</label>
                                        <bootstrap-select  :selectOptions="orderStatuses" :selectedOption="filter.orderStatusId" :elementId="'orderStatusFilterSelect'"
                                                           :returnSelectedOptionText="true"
                                                           @changeSelect="onOrderStatusSelect"></bootstrap-select>
                                    </div>
                                    <div class="col-sm-6 align-self-center">
                                        <div class="float-right pr-3">
                                            <from-date-to-date-pickers  :title="'Date Created'"
                                                                        :fromDate="filter.fromDateCreated"
                                                                        :toDate="filter.toDateCreated"
                                                                        :elementId="'customerDateFilter'"
                                                                        :dateFormat="'DD/MM/YYYY'"
                                                                        @clearDatePicker="onDateFilterClearClick"
                                                                        @fromDateSelected="onFromDateCreatedSelect"
                                                                        @toDateSelected="onToDateCreatedSelect"></from-date-to-date-pickers>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </data-table>
                </div>
                <loading-spinner :showSpinner="loading"></loading-spinner>
            </div>
        </div>
   </div>

    <create-collection-order-modal
            :heading="orderForCollectionModal.heading"
            :modalId="orderForCollectionModal.modalId"
            :showModal="orderForCollectionModal.showModal"
            @placeOrderOkClicked="onPlaceOrderForCollectionOkClicked"></create-collection-order-modal>

    <tracking-history-modal
            :heading="trackingHistoryModal.heading"
            :modalId="trackingHistoryModal.modalId"
            :showModal="trackingHistoryModal.showModal"
            :orderId="trackingHistoryModal.orderId"
            @okButtonClicked="onTrackingHistoryOkButtonClicked"></tracking-history-modal>

    <order-documents-modal
            :orderId="documentsModal.orderId"
            :heading="documentsModal.heading"
            :modalId="documentsModal.modalId"
            :showModal="documentsModal.showModal"
            @closeModal="onDocumentsModalClose"></order-documents-modal>
    
</div>
